<template>
    <div>
        <table class="online-task-list table table-striped">
            <thead>
                <tr>
                    <th colspan="4">
                        <div class="online-task-list__pager">
                            <button :disabled="prevDisabled"
                                    class="btn prev btn-sm btn-default"
                                    @click="paginate('previous')">
                                <i class="fa-solid fa-chevron-left"></i> {{ l('PAGER.PREVIOUS') }}
                            </button>
                            <span>
                                {{ l('PAGER.CURRENT_PAGE') }}
                                {{ currentPage }}
                                {{ l('PAGER.CURRENT_PAGE_OF') }}
                                {{ totalPages }}
                            </span>
                            <button :disabled="nextDisabled"
                                    class="btn next btn-sm btn-default"
                                    @click="paginate('next')">
                                {{ l('PAGER.NEXT') }} <i class="fa-solid fa-chevron-right"></i>
                            </button>
                        </div>
                    </th>
                </tr>
                <tr>
                    <th>{{ l('ONLINE_STATUS.HEADING_NAME') }}</th>
                    <th>{{ l('ONLINE_STATUS.HEADING_TIME') }}</th>
                    <th :colspan="activeTab === 'failed' ? 2 : 1">
                        <div class="flex flex--align-center">
                            <span class="flex--grow flex--shrink">
                                {{ l('ONLINE_STATUS.HEADING_STATUS') }}
                            </span>
                            <button v-if="activeTab === 'failed'"
                                    class="btn btn-sm btn-default flex--no-grow flex--no-shrink"
                                    @click="$emit('clear-failed-tasks')">
                                {{ l('ONLINE_STATUS.CLEAR_FAILED_TASKS') }} <i class="fa-solid fa-trash-can" />
                            </button>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="task in pagedTasks"
                    :key="task.ID">
                    <td>{{ task.description || task.type }}</td>
                    <td>{{ relativeTimeFilter(task.createdAt) }}</td>
                    <td>
                        <div class="flex">
                            <span class="flex--grow flex--shrink">
                                {{ ucfirstFilter(task.status) }}
                                <span v-if="task.attempts > 0"
                                      class="online-task__attempt-count">
                                    {{ task.attempts }}
                                    {{ l(task.attempts === 1 ? 'ONLINE_STATUS.TASK_ATTEMPTS_ONE' : 'ONLINE_STATUS.TASK_ATTEMPTS_PLURAL') }}
                                </span>
                            </span>
                            <span>
                                <i class="fa-solid fa-spinner fa-spin"
                                   :style="{visibility: task.status === 'running' ? 'visible' : 'hidden'}" />
                            </span>
                        </div>

                        <div v-for="(error, i) in task.errors"
                             :key="i"
                             class="online-task__error">
                            <template v-if="error.data && error.data.error">
                                {{ error.data.error }}
                            </template>
                            <template v-else-if="error.message">
                                {{ error.message }}
                            </template>
                        </div>
                    </td>
                    <td v-if="activeTab === 'failed'">
                        <button class="btn btn-sm btn-default pull-right"
                                @click="$emit('clear-failed-task', task.ID)">
                            <i class="fa-solid fa-trash-can" />
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
const numberOfTasksPerPage = 100;

export default {
    name: 'OnlineTaskList',

    props: {
        tasks: {
            type: Array,
            required: true,
        },
        activeTab: {
            type: String,
            default: 'pending',
        },
    },

    emits: [
        'clear-failed-task',
        'clear-failed-tasks',
        'scroll-to-top',
    ],

    data() {
        return {
            currentPage: 1,
            totalPages: 1,
        };
    },

    computed: {
        prevDisabled() {
            return this.currentPage <= 1;
        },
        nextDisabled() {
            return this.currentPage >= this.totalPages;
        },

        pagedTasks() {
            return this.tasks.slice(
                (this.currentPage - 1) * numberOfTasksPerPage,
                this.currentPage * numberOfTasksPerPage
            );
        },
    },

    created() {
        this.totalPages = Math.max(1, Math.floor(this.tasks.length / numberOfTasksPerPage));
    },

    methods: {
        async paginate(direction) {
            if (direction === 'previous') {
                this.currentPage--;
            } else {
                this.currentPage++;
            }
            this.$emit('scroll-to-top');
        },
    },
};

</script>

<style lang="less">
@import "../../../less/variables";

.online-task-list {
    > thead > tr > th {
        vertical-align: middle !important;
    }
    &.table {
        border-collapse: initial;
        thead {
            background: @white;
            top: 0;
            position: sticky;
            inset-block-start: -15px; /* "top" */
            tr {
                th {
                    border-top-color: @white;
                }
            }
            tr:first-of-type {
                th {
                    border-bottom-color: @white;
                }
            }

        }
    }

    .online-task-list__pager {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .fa-regular {
        position: initial;
    }
}

.online-task__attempt-count {
    font-size: 80%;
    display: block;
    margin: 3px 0 0 0;
}

.online-task__error {
    margin: 3px 0 0 0;
    font-size: 80%;
    display: block;
}
</style>
